/* eslint-disable no-unused-vars */
import React, { createContext, useReducer } from 'react';
/* eslint-enable no-unused-vars */

const initial = window.rexSurveyConfig || {};

const events = {
  INITIAL: 'initial',
  UPDATE: 'update',
  // @update - 20191205
  RESET: 'reset',
};

const initialState = {
  type: events.INITIAL,
  config: { ...initial },
  step: -1,
  nps: {
    name: '',
    value: '',
  },
};

const reducer = (requestState = { ...initialState }, action = null) => {
  /**
   * 前回 state の参照をカットします
   * @type {*}
   */
  const state = { ...requestState };
  // action check - 不正値の時は前回値をかえします
  if (!action || !action.type) {
    return state;
  }

  // type check
  switch (action.type) {
    case events.UPDATE: {
      // 更新
      state.type = action.type;
      // state.config = merge({}, state.config, action.config);
      state.config = { ...action.config };
      state.step = action.step;
      return state;
    }
    // case events.INITIAL: {
    //   // 初期値
    //   return { ...initialState };
    // }
    // default: {
    //   // その他 - illegal type - error にならないようにコピーする
    //   state.type = events.INITIAL;
    //   state.config = { ...action.config };
    //   state.step = action.step;
    //   return state;
    // }
    // @update - 20191205
    case events.RESET: {
      state.type = action.type;
      state.config = { ...initial };
      state.step = -1;
      state.nps.name = '';
      state.nps.value = '';
      return state;
    }
    // @update - 20191205
    case events.INITIAL: {
      state.type = action.type;
      return state;
    }
    // @update - 20191205
    default: {
      return state;
    }
  }
};

/**
 * config 更新のための context を作成します
 * @type {React.Context<{type: string, config: any}>}
 */
const Context = createContext(initialState);

/**
 * context Provider - 最上位に配置します
 * - {@link reducer} Reducer を作成し state / dispatch を value 設定します
 * @param {*} props - React.props
 * @return {*} `Provider` component を返します
 * @constructor
 */
const Provider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <Context.Provider value={{ state, dispatch }}>
      {props.children}
    </Context.Provider>
  );
};

const survey = {
  events,
  Context,
  Provider,
  initial: initialState,
};

export default survey;



// WEBPACK FOOTER //
// ./src/phase2/survey/context/survey.js